import { useMutation } from "@tanstack/react-query";
import {
  acceptInvitation,
  activateUser,
  inviteUser,
  registerIdentity,
  resendActivationEmail,
  resendInvite,
  requestPasswordReset,
  resetPassword,
} from "../services/identityApi";

function getErrorMessage(error, fallback) {
  return error.response?.data?.message || error.message || fallback;
}

export function useRegisterIdentity(handleSuccess, handleError, extendedLog) {
  return useMutation({
    mutationFn: registerIdentity,
    onSuccess: (data) => {
      console.log("Identity registration completed successfully!", data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = getErrorMessage(error, "Identity registration failed");
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage });
    },
  });
}

export function useInviteUser(handleSuccess, handleError, extendedLog) {
  return useMutation({
    mutationFn: inviteUser,
    onSuccess: (data) => {
      console.log("User invitation sent successfully!", data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = getErrorMessage(error, "User invitation failed");
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage });
    },
  });
}

export function useResendInvite(handleSuccess, handleError, extendedLog) {
  return useMutation({
    mutationFn: resendInvite,
    onSuccess: (data) => {
      console.log("User invitation resent successfully!", data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = getErrorMessage(error, "User invitation resend failed");
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage });
    },
  });
}

export function useResendActivationEmail(handleSuccess, handleError, extendedLog) {
  return useMutation({
    mutationFn: resendActivationEmail,
    onSuccess: (data) => {
      console.log("Activation email resent successfully!", data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = getErrorMessage(error, "Activation email resend failed");
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage });
    },
  });
}

export function useAcceptInvitation(handleSuccess, handleError, extendedLog) {
  return useMutation({
    mutationFn: ({ tokenHash, userInfo }) => acceptInvitation(tokenHash, userInfo),
    onSuccess: (data) => {
      console.log("Invitation accepted successfully!", data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = getErrorMessage(error, "Invitation acceptance failed");
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage });
    },
  });
}

export function useActivateUser(handleSuccess, handleError, extendedLog) {
  return useMutation({
    mutationFn: activateUser,
    onSuccess: (data) => {
      console.log("User activated successfully!", data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = getErrorMessage(error, "User activation failed");
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage });
    },
  });
}

export function useRequestPasswordReset(handleSuccess, handleError, extendedLog) {
  return useMutation({
    mutationFn: ({ email, slug, turnstileToken }) => requestPasswordReset(email, slug, turnstileToken),
    onSuccess: (data) => {
      console.log("Password reset request sent successfully!", data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = getErrorMessage(error, "Password reset request failed");
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage });
    },
  });
}

export function useResetPassword(handleSuccess, handleError, extendedLog) {
  return useMutation({
    mutationFn: ({ tokenHash, newPassword, turnstileToken }) => resetPassword(tokenHash, newPassword, turnstileToken),
    onSuccess: (data) => {
      console.log("Password reset successfully!", data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = getErrorMessage(error, "Password reset failed");
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage });
    },
  });
}
